import { title } from 'process';

import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { Question, Survey } from '../shared/model-service';
import { PopupService } from '../shared/popup-service';
import { SurveyAnswerService } from '../../public-api';

@Component({
  selector: 'app-smiley',
  templateUrl: './smiley.component.html',
  styleUrls: ['./smiley.component.css']
})
export class SmileyComponent implements OnInit, AfterViewInit{
  panelOpenState = true;
  show :boolean = false;
  @Input() Question: Question;
  @Input() SurveyBase : Survey
  surveyEnd : boolean = false;
  questiondsIdLinks : number[] = [];
  questions: Question[]= [];
  result: Question;
  selectedSmiley: number;
  response: string = "";
  timer: any;
  popupService : PopupService
  constructor(private dialog : MatDialog, private surveyService : SurveyAnswerService) { }

  ngOnInit(): void {
    this.popupService = new PopupService(this.dialog);
    if(this.Question.result != "" && this.Question.result != null)
    {
      this.treatEditSurvey();
    } else {
      this.Question.result = "";
    }

  }

  ngAfterViewInit(): void {
    this.Question.result = this.Question.result;
    
  }
  
  onNgModelChange(optionselected)
  {

    if(this.timer != null ){
      clearTimeout(this.timer)
     }
   
     this.timer = setTimeout(() => {
       this.panelOpenState = false;
     }, 5000); 

     

    this.Question.options.forEach(option => {
      option.result = null
    });
     
    this.SurveyBase.finish = false;
    this.Question.result = optionselected[0].title
    this.response = optionselected[0].title
    this.show = true;
    this.questiondsIdLinks = [];
    this.questions = [];

    let option = this.Question?.options.find(x=> x.title == optionselected[0].title)
    if (option?.links.length > 0) {

      option?.links.forEach(element => {
        element.questionDestinationId;
        this.questiondsIdLinks.push(element.questionDestinationId);
        /** Open popus */
      if(element.popupDestinationId != null )
      {
          this.popupService.openPopupDialog(element.popupDestinationId,this.SurveyBase);
      }

      /**open tip */
      if(element.tipDestinationTipId != null )
      {
        this.popupService.openTipDialog(element.tipDestinationTipId);
      }
      });
      this.questiondsIdLinks.forEach(element => {
        this.result = this.SurveyBase.questions.find(x => x.id == element);
        if (this.result != null) {
       
          this.questions.push(this.result);
          
        }
      })
      
    }
        
  }
  
  treatEditSurvey()
  {   
    this.panelOpenState = false;
    this.show = true;
    let optionSelected = this.Question.options.find(x=>x.title == this.Question.result);
  
    this.response =  optionSelected.title;
    optionSelected?.links.forEach(element => {
      element.questionDestinationId;
      this.questiondsIdLinks.push(element.questionDestinationId);
      /** Open popus */
       this.questiondsIdLinks.forEach(element => {
        this.result = this.SurveyBase.questions.find(x => x.id == element);
        if (this.result != null) {
       
          this.questions.push(this.result);
        }
      })
    })
 }
  

}
